import { api, generateCRUDInterface, getCurrentUser } from "aldoo-ra/API"

const adsAPI = api("aldoo-ads")
const crudAPI = api("crud")
const apiKeysAPI = api("api-keys")
const permissionsAPI = api("permissions")

// CRUD interfaces for the ads concept chain (server models live in
// aldoo-na/aldoo-ads/db/schemas — managed through the generic crud endpoint)
export const CampaignCRUD = generateCRUDInterface(crudAPI, "AdCampaign")
export const AdCRUD = generateCRUDInterface(crudAPI, "Ad")
export const AssetCRUD = generateCRUDInterface(crudAPI, "AdAsset")
export const AccountCRUD = generateCRUDInterface(crudAPI, "AdAccount")

// ── aldoo-ads module actions ────────────────────────────────────────────────

/** KPIs for { level: 'account'|'campaign'|'ad', id, from?, to?, account? } */
export const GetStats = async (params) => adsAPI({ stats: params })

/** Daily KPI time-series for the charts. Same params as GetStats. */
export const GetSeries = async (params) => adsAPI({ series: params })

/** Local + connected accounts. expand=<remoteAccountId> pulls its campaign tree. */
export const ListAccounts = async (expand) =>
  adsAPI({ list_accounts: expand ? { expand } : {} })

/** Link a remote install: validates url+key against its remote_campaigns. */
export const ConnectAccount = async ({ api_url, access_key, name }) =>
  adsAPI({ connect_account: { api_url, access_key, name } })

/** Render an asset (saved or raw html) with its ad's variables. */
export const PreviewAsset = async ({ asset, html, ad }) =>
  adsAPI({ preview: { asset, html, ad } })

// ── Access keys (ads:read) ──────────────────────────────────────────────────

/**
 * Create an access key another site can use to read this account's ads
 * data. Key is bound to the current admin user; the ads:read permission is
 * granted to that user so APIKeyCredentials resolves it on inbound calls.
 */
export const CreateAdsAccessKey = async (description = "Aldoo Ads access key") => {
  const user = getCurrentUser()
  if (!user?._id) return { error: "not_authenticated" }
  const created = await apiKeysAPI({
    create: { targetUserId: user._id, issuedBy: user._id, description },
  })
  if (!created?.result) return created
  await permissionsAPI({
    grant_permission: { user: user._id, permissions: ["ads:read"] },
  })
  return created
}

/** List existing API keys (newest first). */
export const ListAccessKeys = async () => {
  const res = await crudAPI({
    get: { model: "APIKey", match: {}, sort: { createdAt: -1 }, itemsPerPage: 50 },
  })
  return res?.data || []
}
